import React, { Component } from "react";
import PropTypes from "prop-types";
import { IndexLink, Link } from "react-router";

class ResultLink extends Component {
  static contextTypes = {
    router: PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);

    this.state = {
      useHash: false
    };

    if (this.props.to.indexOf("#") !== -1) {
      if (
        this.props.to
          .toLowerCase()
          .indexOf(window.location.pathname.toLowerCase() + "#") === 0
      ) {
        this.state.useHash = true;
      }
    }
  }

  onClick() {
    if (!this.state.useHash) {
      window.nexoidScrollBarTopQuick(0);
    }
    if (typeof this.props.onClick === "function") {
      this.props.onClick();
    }
  }

  render() {
    return (
      <div>
        {this.state.useHash === true ? (
          <a href={this.props.to} onClick={this.onClick}>
            <div className="resultLink">
              <div className="resultLinkPrimary">{this.props.primary}</div>
              <div className="resultLinkSecondary">{this.props.secondary}</div>
            </div>
          </a>
        ) : (
          <Link onClick={this.onClick} to={this.props.to}>
            <div className="resultLink">
              <div className="resultLinkPrimary">{this.props.primary}</div>
              <div className="resultLinkSecondary">{this.props.secondary}</div>
            </div>
          </Link>
        )}
      </div>
    );
  }
}

export default ResultLink;



// WEBPACK FOOTER //
// ./src/components/Search/ResultLink.js